import {Radios} from 'mui-rff';
import React from "react";

export default function RadiosAdapter(props) {

  return (<Radios
    {...props}
  />)

}